import { BaseResponse } from '@monorepo/client-common';
import { CountryFilter, UserTermsAndConditionsConfig } from '@monorepo/types';
import CrudService from '../core/crud-service';

export default class ApplicationConfigService extends CrudService {
  static override route = 'application-config';

  async getCountryFilter() {
    try {
      const response = await this.httpService.get<BaseResponse<CountryFilter>>(
        `${this.path}/countries-filter`,
      );
      return response.data;
    } catch {
      throw new Error('Error fetching country filter');
    }
  }

  async getUserTermsAndConditions() {
    try {
      const response = await this.httpService.get<
        BaseResponse<UserTermsAndConditionsConfig>
      >(`${this.path}/user-terms-and-conditions`);
      return response.data;
    } catch {
      throw new Error('Error fetching user terms and conditions');
    }
  }
}
